import { z } from "zod";
export const NotificationTypeEnum = z.enum([
    "new_message",
    "new_course",
    "new_module",
    "new_review",
    "system",
]);
export const NotificationSchema = z.object({
    notification_id: z.string(),
    type: NotificationTypeEnum,
    title: z.string(),
    message: z.string(),
    is_read: z.boolean().default(false),
    link: z.string().nullable().optional(),
    created_at: z.string(),
    metadata: z.record(z.string(), z.unknown()).optional(),
});
export const CreateBroadcastNotificationPayloadSchema = z.object({
    title: z.string().min(1).max(200),
    message: z.string().min(1).max(1000),
    link: z.string().nullable().optional(),
});
